
const Api = window.location.origin;
// const Api = "http://localhost:1301";
export default Api;